import { render, staticRenderFns } from "./MilestonesBlock.vue?vue&type=template&id=963b2738&scoped=true&"
import script from "./MilestonesBlock.vue?vue&type=script&lang=ts&"
export * from "./MilestonesBlock.vue?vue&type=script&lang=ts&"
import style0 from "./MilestonesBlock.vue?vue&type=style&index=0&id=963b2738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b2738",
  null
  
)

export default component.exports